import { Suspense, lazy } from 'react';
import { BrowserRouter, Switch, Route, Link } from 'react-router-dom';

import Credentials from './components/Credentials';
import Forms from './components/Forms';

import getBasename from './getBasename';

import './styles/general.css';
import Hints from './components/Hints';

const GameWindow = lazy(() => import('./frames/GameWindow'));
const ServerContent = lazy(() => import('./frames/server/ServerContent'));

//  <Credentials>
//    <Suspense fallback="">
//      <GameWindow />
//    </Suspense>

export default function Main() {
  return (
    <Credentials>
      <Hints>
        <Forms>
          <BrowserRouter basename={getBasename()}>
            <Suspense fallback=""> 
              <Switch>
                <Route exact path={"/"}>
                  <GameWindow />
                </Route>
                {/*<Route exact path={"/admin"} component={AdminWindow} />*/}
                <Route exact path='/comments' component={GameWindow} />
                <Route exact path='/comments/:commentId' component={GameWindow} />
                {/*Рендер произвольной страницы с сервера*/}
                <Route path="/" render={(props) => <ServerContent url={getBasename() + "/api" + props.location.pathname} /> } />
              </Switch>
            </Suspense>
          </BrowserRouter>
        </Forms>
      </Hints>
    </Credentials>
  );
}
